import { polygon } from 'viem/chains';
import { Config } from './config.interface';

export const productionConfig: Config = {
  environment: 'production',
  smartWalletEnabled: true,
  contracts: {
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    phnm: '0x35d4F6D876d6c14775DF8A74b8dE3A699cF458AC',
    tables: '0xC10e197E783394D08310F5013F05362a64a891C4',
    redemption: '0xb52e266741CC514E1CB458C86985eC86B4d8025E',
    redemptionVault: '0xe1de6A1C89c626c40851FC80f8e2956B94c743ab',
  },
  chain: polygon,
  blockExplorerUrl: 'https://polygonscan.com/',
  usdtDecimals: 6,
  phnmDecimals: 18,
};
